<template>
  <Menu
    ref="sideMenu"
    :active-name="$route.name"
    :open-names="openNames"
    :theme="menuTheme"
    width="auto"
    @on-select="changeMenu"
  >
    <template v-for="item in menuList">
      <!-- <MenuItem v-if="item.children.length<=1" :name="item.children[0].name" :key="'menuitem' + item.name"> -->
      <MenuItem :name="item.name" :key="'menuitem' + item.name">
        <Icon :custom="item.icon" :size="iconSize" :key="'menuicon' + item.name"></Icon>
        <i class="spirit-dark book middle"></i>
        <span class="layout-text" :key="'title' + item.name">{{ itemTitle(item) }}</span>
        <span class="passport-menu-badge" v-if="item.name === 'standby_home' && standbyNum > 0">{{
          standbyNum > 99 ? '99+' : standbyNum
        }}</span>
      </MenuItem>

      <!-- <Submenu v-if="item.children.length > 1" :name="item.name" :key="item.name"> -->
      <Submenu v-if="1 == 11" :name="item.name" :key="item.name">
        <template slot="title">
          <Icon :type="item.icon" :size="iconSize"></Icon>
          <i class="spirit-dark book middle"></i>
          <span class="layout-text">{{ itemTitle(item) }}</span>
        </template>
        <template v-for="child in item.children">
          <MenuItem :name="child.name" :key="'menuitem' + child.name">
            <Icon :type="child.icon" size="12" :key="'icon' + child.name"></Icon>
            <span class="layout-text" :key="'title' + child.name">{{ itemTitle(child) }}</span>
          </MenuItem>
        </template>
      </Submenu>
    </template>
  </Menu>
</template>

<script>
import { post } from 'pangu-components-plus'
export default {
  name: 'sidebarMenu',
  props: {
    menuList: Array,
    iconSize: Number,
    menuTheme: {
      type: String,
      default: 'dark',
    },
    openNames: {
      type: Array,
    },
  },
  computed: {
    standbyNum() {
      return this.$store.state.user.standbyNum
    },
  },
  methods: {
    changeMenu(active) {
      this.$emit('on-change', active)
    },
    itemTitle(item) {
      if (typeof item.title === 'object') {
        return this.$t(item.title.i18n)
      } else {
        return item.title
      }
    },
    async getStandbyNum() {
      const [res] = await post('rest/main/task/queryPaged', {
        criteriaCode: 'PASSPORT_WORKBENCH_MESSAGE_QUERY',
        pageNo: 1,
        pageSize: 20,
        tableCode: 'PASSPORT_WORKBENCH_MESSAGE_TABLE',
        sortings: [],
        parameters: {
          complete: false,
          method: 'EVENT_METHOD_20',
        },
      })
      if (res) {
        this.$store.commit('setStandbyNum', res.total?.count_status ?? 0)
      }
    },
  },
  mounted() {
    this.getStandbyNum()
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.sideMenu) {
        this.$refs.sideMenu.updateOpened()
      }
    })
  },
}
</script>
<style lang="scss">
.passport-menu-badge {
  background-color: #ff1212;
  color: #ffffff;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  border-radius: 8px;
  padding: 0 4px;
  position: absolute;
  top: 5px;
}
</style>
